import { useEffect, useState, useMemo } from 'react';
import { getCookie } from '../utils';
import { Location } from '../types/Location.interface';

type UseCookieLocationReturn = [
    selectedLocation: number | string,
    setSelectedLocation: (location: number | string) => void,
    selectedLocationData: Location | string
];

export function useCookieLocation(locations: Location[]): UseCookieLocationReturn {
    const [selectedLocation, setSelectedLocation] = useState<number | string>('');
    const [selectedLocationData, setSelectedLocationData] = useState<Location | string>('');

    useEffect(() => {
        if (locations.length > 0) {
            const cookieValue = getCookie('location');
            const cookieLocation = parseInt(cookieValue || '0', 10);

            const cookieLocationInLocations = locations.find((location) => location.id === cookieLocation);

            if (cookieLocationInLocations && !isNaN(cookieLocation)) {
                setSelectedLocation(cookieLocation);
                setSelectedLocationData(cookieLocationInLocations);
            } else {
                const firstLocation = locations[0];
                setSelectedLocation(firstLocation?.id || '');
                setSelectedLocationData(firstLocation || '');
            }
        }
    }, [locations]);

    return useMemo(
        () => [selectedLocation, setSelectedLocation, selectedLocationData],
        [selectedLocation, selectedLocationData]
    );
}
